// Team config — to swap real photos later, set `photoUrl` on each member.
// The <Avatar/> component renders initials in a circular slot when photoUrl is null.
//
// Nathan + Bradley photos and bios are sourced verbatim from the existing
// rentanything.ai/about page (downloaded into /public/team/).
// Kylen is new — he replaces Aaron Boss on the new launch site; keep his
// placeholder avatar until a real photo arrives.

export const TEAM = [
  {
    name: "Nathan Boucher",
    title: "CEO & Co-Founder",
    initials: "NB",
    photoUrl: "/team/nathan.jpg",
    bio: "With over 20 years of experience in high-level technology roles, Nathan has a proven track record of leading digital transformation and IT strategy across multiple industries. From Chief Information Officer to Chief Technology Officer, his leadership has been pivotal in overseeing complex software development, cloud transitions, and full-scale ERP implementations. Nathan's expertise spans enterprise security, software development life cycles, and managing technical teams to drive innovation and operational success. His ability to balance strategic vision with hands-on execution makes him a driving force behind the technology powering our platform.",
  },
  {
    name: "Bradley Sapp",
    title: "Project Manager",
    initials: "BS",
    photoUrl: "/team/bradley.jpg",
    bio: "With a diverse background in project management across various industries, Bradley brings a wealth of experience in leading teams, optimizing processes, and delivering successful projects. His previous roles have equipped him with the ability to adapt and excel in fast-paced environments, making him a natural fit to guide the operational side of our platform's development. Bradley's strong leadership and hands-on experience have been crucial in driving our company's vision forward from concept to launch.",
  },
  {
    name: "Kylen Blom",
    title: "Co-Founder & VP of Sales",
    initials: "KB",
    photoUrl: "/team/kylen.jpg",
    bio: "Sales and marketing leader with a track record of scaling B2B SaaS in operator-heavy markets. Spends most days talking to rental operators about what's broken — and bringing that back to the product. [Bio to be updated.]",
  },
];
